/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $LineupTypeList = {
    type: 'array',
    contains: {
        type: 'LineupType',
    },
} as const;
